import R from 'ramda';
import dispatch from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/dispatch';
import { VtoEventsNames } from './hooks/events';

const eventGenerator = ({
  eventName,
  product,
  selectedProductSwatch,
  selectedFilter,
  selectedFilters,
}) => {
  const selectedVariant = R.find(
    R.propEq('sku', R.prop('sku', selectedProductSwatch)),
    R.prop('variants', product)
  );
  const position = selectedVariant
    ? R.indexOf(selectedVariant, R.prop('variants', product)) + 1
    : 0;

  switch (eventName) {
    case VtoEventsNames.PRODUCT_TRY_ON:
      return {
        event: VtoEventsNames.PRODUCT_TRY_ON,
        eventInfo: {
          eventAction: 'product try on',
          eventDetail: R.prop('title', product),
        },
        productInfo: [
          {
            position,
            variant: R.prop('itemName', selectedProductSwatch),
            productId: R.prop('sku', selectedProductSwatch),
            name: R.prop('title', product),
          },
        ],
      };

    case VtoEventsNames.VTO_PAGE_IMPRESSION:
      return {
        event: VtoEventsNames.VTO_PAGE_IMPRESSION,
        page: {
          pageName: 'vto landing page',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto page impression',
          eventDetail: 'vto landing page',
        },
      };

    case VtoEventsNames.VTO_PRODUCT_EVENT_EXPERIENCE_LOADED:
      return {
        event: 'vto-product-event',
        eventInfo: {
          eventAction: 'vto started',
          eventDetail: R.prop('title', product),
        },
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        productInfo: [
          {
            position,
            variant: R.prop('itemName', selectedProductSwatch),
            productId: R.prop('sku', selectedProductSwatch),
            name: R.prop('title', product),
          },
        ],
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_CAMERA_OPEN:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'camera loaded',
          eventDetail: 'camera loaded',
        },
      };

    case VtoEventsNames.VTO_PRODUCT_EVENT_SHADE_SELECT:
      return {
        event: 'vto-product-event',
        eventInfo: {
          eventAction: 'vto shade selected',
          eventDetail: R.prop('title', product),
        },
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        productInfo: [
          {
            position,
            variant: R.prop('itemName', selectedProductSwatch),
            productId: R.prop('sku', selectedProductSwatch),
            name: R.prop('title', product),
          },
        ],
      };

    case VtoEventsNames.VTO_PRODUCT_EVENT_SHOP_NOW:
      return {
        event: 'vto-product-event',
        eventInfo: {
          eventAction: 'vto shop now',
          eventDetail: R.prop('title', product),
        },
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        productInfo: [
          {
            position,
            variant: R.prop('itemName', selectedProductSwatch),
            productId: R.prop('sku', selectedProductSwatch),
            name: R.prop('title', product),
          },
        ],
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_REMOVE_COLOUR:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'remove colour',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_SELECT_LINE:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'product line selected',
          eventDetail: R.prop('title', product),
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_PHOTO_SAVED:
      return {
        event: 'vto-product-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto photo downloaded',
          eventDetail: R.prop('title', product),
        },
        productInfo: [
          {
            position,
            variant: R.prop('itemName', selectedProductSwatch),
            productId: R.prop('sku', selectedProductSwatch),
            name: R.prop('title', product),
          },
        ],
      };

    case VtoEventsNames.VTO_ERROR_CAMERA_FAILED:
      return {
        event: 'vto-error',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto unable to access camera',
          eventDetail: 'none',
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_CONSENT_SHOWED:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'privacy policy impression',
          eventDetail: 'privacy policy impression',
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_CONSENT_AGREED:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'privacy policy agreement',
          eventDetail: 'privacy policy agreement',
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_ICON_KEY_VIEW_CLOSED:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'close vto tips',
          eventDetail: 'close vto tips',
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_GET_STARTED:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto get started',
          eventDetail: ' vto get started ',
        },
      };

    case VtoEventsNames.VTO_PRODUCT_EVENT_SLIDER_COMPARE:
      return {
        event: 'vto-product-event',
        eventInfo: {
          eventAction: 'vto compare shades',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        productInfo: [
          {
            position,
            variant: R.prop('itemName', selectedProductSwatch),
            productId: R.prop('sku', selectedProductSwatch),
            name: R.prop('title', product),
          },
        ],
      };

    case VtoEventsNames.VTO_PRODUCT_EVENT_SLIDER_COMPARE_CLOSED:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto slider closed',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_PHOTO_TAKEN:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto photo taken',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    case VtoEventsNames.VTO_ERROR_NO_HAND_DETECTED:
      return {
        event: 'vto-error',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto no hand detected',
          eventDetail: 'vto no hand detected',
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_FILTER_APPLY:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'filter applied',
          eventDetail: selectedFilters,
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_FILTER_SELECT:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'filter clicked',
          eventDetail: selectedFilter,
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_FILTER_RESET:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'filter clear all',
          eventDetail: selectedFilters,
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_ICON_KEY_BTN_CLICKED:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'open vto tips',
          eventDetail: 'open vto tips',
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_SELECT_FILTER_OPEN:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'filter opened',
          eventDetail: 'filter opened',
        },
      };

    case VtoEventsNames.VTO_GENERIC_EVENT_CLOSED:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto widget closed ',
          eventDetail: R.prop('title', product),
        },
      };

    case VtoEventsNames.SPLIT_FOUR_WAY:
      return {
        event: 'vto-product-event',
        eventInfo: {
          eventAction: 'vto four way compare',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        productInfo: [
          {
            position,
            variant: R.prop('itemName', selectedProductSwatch),
            productId: R.prop('sku', selectedProductSwatch),
            name: R.prop('itemName', selectedProductSwatch),
          },
        ],
      };

    case VtoEventsNames.SPLIT_FOUR_WAY_CLOSED:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto four way compare disabled',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    case VtoEventsNames.VTO_DOWNLOAD_PICTURE:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto download picture open',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    case VtoEventsNames.VTO_DOWNLOAD_PICTURE_DOWNLOAD:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto download picture download',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    case VtoEventsNames.VTO_SHARE_EMAIL:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto share email open',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    case VtoEventsNames.VTO_SHARE_EMAIL_CONFIRM:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto share email confirm',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    case VtoEventsNames.VTO_SHARE_EMAIL_SEND:
      return {
        event: 'vto-generic-event',
        page: {
          pageName: 'try on',
          pageType: 'vto',
        },
        eventInfo: {
          eventAction: 'vto share email send',
          eventDetail: R.prop('itemName', selectedProductSwatch),
        },
      };

    default:
      return {};
  }
};

export const dispatchEvent = ({ product, selectedProductSwatch }) => ({
  eventName,
  selectedFilter,
  selectedFilters,
}) => {
  const event = eventGenerator({
    eventName,
    product,
    selectedProductSwatch,
    selectedFilter,
    selectedFilters,
  });

  dispatch({ eventName: event.event, detail: event });
};
